import { useTheme } from "@/theme/ThemeProvider";
import { Text, TextStyle } from "react-native";

type Props = {
  children: string;
  style?: TextStyle;
};

export function ErrorText({ children, style }: Props) {
  const { theme } = useTheme();

  return (
    <Text style={[{ color: theme.color.dangerText, fontSize: theme.fontSize.small }, style]}>
      {children}
    </Text>
  );
}
